import classnames from 'classnames';
import type { FunctionComponent } from 'react';

import { isUkPlatform } from '@/domains/core/settings/utils';

import { QuickFreeDeliveryFilter } from './components/QuickFreeDeliveryFilter/QuickFreeDeliveryFilter';
import { QuickManoExpressDeliveryFilter } from './components/QuickManoExpressDeliveryFilter/QuickManoExpressDeliveryFilter';
import { QuickOpenFilterPanel } from './components/QuickOpenFilterPanel/QuickOpenFilterPanel';
import { QuickOpenSortModal } from './components/QuickOpenSortModal/QuickOpenSortModal';
import { QuickRatingsFilter } from './components/QuickRatingsFilter/QuickRatingsFilter';

import styles from './QuickFilters.module.scss';

interface Props {
  className?: string;
  onToggleFiltersPanel?: () => void;
}

export const QuickFilters: FunctionComponent<Props> = ({
  className,
  onToggleFiltersPanel,
}) => {
  const rootClassnames = classnames(styles.root, className);

  return (
    <div className={rootClassnames}>
      <div className={styles.slider}>
        <div className={styles.scroller}>
          <QuickOpenFilterPanel onClick={onToggleFiltersPanel} />

          {!isUkPlatform() && <QuickManoExpressDeliveryFilter />}

          <QuickFreeDeliveryFilter />

          <QuickRatingsFilter />

          <QuickOpenSortModal />
        </div>
      </div>
    </div>
  );
};
